import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FINAL_CTA } from "@/content/landing";
import Reveal from "./Reveal";

export default function FinalCta() {
  return (
    <section className="final-cta">
      <Reveal className="final-cta-box">
        <h2>{FINAL_CTA.title}</h2>
        <p>{FINAL_CTA.lead}</p>
        <div className="hero-actions">
          <Link to={FINAL_CTA.cta.to} state={{ mode: "register" }} className="button button-light" data-testid={FINAL_CTA.cta.testid}>{FINAL_CTA.cta.label}<ArrowRight size={14} /></Link>
          <Link to={FINAL_CTA.secondary.to} className="landing-link landing-link-light">{FINAL_CTA.secondary.label}</Link>
        </div>
      </Reveal>
    </section>
  );
}
